'use strict';
import React from 'react';
import {I18nMessage} from '../../../components/I18nMessage';
import {ViewHeader} from '../../../components/views/ViewHeader';


export function SettingsViewHeaderView() {
  return (
    <ViewHeader className="LegacyHeader">
      <span className="AppNavigationLayout__header__title">
        <I18nMessage message="app.settings.header.label" />
      </span>
    </ViewHeader>
  );
}

SettingsViewHeaderView.propTypes = {};



// WEBPACK FOOTER //
// ./src/js/settings/components/SettingsViewHeader/SettingsViewHeaderView.js